const $$splitComponentImporter = () => import('/app/apps/web/src/routes/_app.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { onboardingGuard } from "./_app/guards";

// Router-level `defaultErrorComponent` (see `router.tsx`) renders `AppError`
// for any boundary that doesn't override — including this layout — so no
// explicit `errorComponent` here.
export const Route = createFileRoute("/_app")({
  // Mirrors Next's `onboardingGuard()` call in `(app)/layout.tsx`: any
  // authenticated user who hasn't completed onboarding is redirected. We run
  // it in `beforeLoad` so every child loader sees a post-guard world.
  beforeLoad: ({
    context: {
      queryClient
    },
    location
  }) => onboardingGuard({
    queryClient,
    location
  }),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});

// No nested IntlProvider here: the root route ships the full message tree,
// so `useTranslations` inside Header/Footer/BottomNav/ListsProvider resolves
// against the root. An intermediate scoped provider (as in the original
// Next.js port) stripped namespaces from child routes — e.g. the `artist`
// bucket disappearing from `useMessages()` in `_app/artist/$id`'s scope
// picker — without saving any bundle size, since the root already has
// everything.